export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-banner@2x-af7686953525f962d0c653a6d936b05e.png";